export enum HcResponseAction {
  MARK_OK = 'HcResponseAction.mark_ok',
  NOTIFY_OK = 'HcResponseAction.notify_ok',
  NOTIFY_NOT_OK = 'HcResponseAction.notify_not_ok',
  NOTIFY_EMERGENCY = 'HcResponseAction.notify_emergency',
  NOTIFY_NO_RESPONSE = 'HcResponseAction.notify_no_response',
}

export enum HcTimeOutAction {
  RETRY = 'HcTimeOutAction.retry',
  NOTIFY_NO_RESPONSE = 'HcTimeOutAction.notify_no_response',
}
